import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ViewEngine } from '../types/view-engine.interface';
import { cloneDeep } from 'lodash';

@Injectable()
export class SxInternalStateDesignerService {
    
  // The name of the porperty at the current submodal
  private currentPropertyModal = new BehaviorSubject<string>(null);
  private currentSearchAttr = new BehaviorSubject<string>(null);
  private viewEngines = new BehaviorSubject<ViewEngine[]>(null);
  constructor() { }

  getCurrentPropertyModal(): string {
    return this.currentPropertyModal.getValue();
  }
  
  setCurrentPropertyModal(currentPropertyModal: string) {
    this.currentPropertyModal.next(currentPropertyModal);
  }

  getCurrentFilterAttr(): string {
    return this.currentSearchAttr.getValue() ? this.currentSearchAttr.getValue() : '';
  }
  
  setCurrentFilterAttr(currentSearchAttr: string) {
    this.currentSearchAttr.next(currentSearchAttr);
  }

  setViewEngines(viewEngines: ViewEngine[]) {
    this.viewEngines.next(viewEngines);
  }

  getViewEngines(): ViewEngine[] {
    const viewEnginesValues = cloneDeep(this.viewEngines.getValue());
    return viewEnginesValues;
  }
  
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/services/internal-state-designer-service.ts